import {Constructor} from '~shared/types';

type Instance<Value extends Constructor> = Value extends {
    new (...args: unknown[]): infer InstanceType;
}
    ? InstanceType
    : never;

export const instanceOf = <Base extends Constructor>(
    value: unknown,
    base: Base,
): value is Instance<Base> => value instanceof base;
